// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3541) return "static/chunks/636fda33-c3e8fbf9f62ab290.js";
	if (chunkId === 5738) return "static/chunks/5738-ce61cef36ee17a09.js";
	if (chunkId === 4779) return "static/chunks/4779-59320d8497f193f0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1382 ? "bbfbfb6c" : chunkId) + "." + {"367":"0dac8baca81fd0cb","1382":"39f52e6dd2ec20d7","1951":"da96380d18893ff5","3181":"509982a3a77bed8e","5386":"bf1479456f19bd3b"}[chunkId] + ".js";
};